<template>
    <VueSlickCarousel
        :lazyLoad="'ondemand'"
        :autoplay="autoplay"
        :arrows="arrows"
        :dots="dots"
        :focusOnSelect="focusOnSelect"
        :infinite="infinite"
        :speed="speed"
        :slidesToShow="slidesToShow"
        :slidesToScroll="slidesToScroll"
        :touchThreshold="touchThreshold" ,
        :responsive="[
                                            {
                                            breakpoint: 767,
                                            settings: {
                                            slidesToShow: 1,
                                            },
                                            },
                                            {
                                            breakpoint: 991,
                                            settings: {
                                            slidesToShow: 3,
                                            },
                                            },
                                            ]"


        class="product-nav-slider"

    >

        <div v-for="(image,index) in images" :key="index">
            <div class="category-item">
                <img :src="image" alt="">
            </div>
        </div>
        <template #prevArrow="arrowOption">
            <div class='slick-prev slick-arrow'><img src='assets/images/prev-round-arrow.svg'></div>
        </template>
        <template #nextArrow="arrowOption">
            <div class='slick-next slick-arrow'><img src='assets/images/next-round-arrow.svg'></div>

        </template>


    </VueSlickCarousel>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

export default {
    props: ['images', 'autoplay', 'arrows', 'dots', 'focusOnSelect', 'infinite', 'speed', 'slidesToShow', 'slidesToScroll', 'touchThreshold'],
    components: {
        VueSlickCarousel
    }
}
</script>
